import contactImg from "./images/contact/contactImg.jpg";
import areo from './images/projects/areo-md.png';
import theGallery from './images/projects/the-gallery.png';
import spark from './images/projects/spark-learning.png';
import exitek from './images/projects/exitek.png';

const shakilAhmmed = "/shakilAhmmed.webp";

export {
  contactImg,
  shakilAhmmed,
  areo,
  theGallery,
  spark,
  exitek,
};
